import { render } from "./MessageDeletedComponent.vue?vue&type=template&id=6f72388e&scoped=true"
import script from "./MessageDeletedComponent.vue?vue&type=script&lang=js"
export * from "./MessageDeletedComponent.vue?vue&type=script&lang=js"

import "./MessageDeletedComponent.vue?vue&type=style&index=0&id=6f72388e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f72388e"]])

export default __exports__